import { Box, Button } from '@mui/material';
import {
  UnfoldMore as UnfoldMoreIcon,
  UnfoldLess as UnfoldLessIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type Props = {
  onExpandAll: () => void;
  onCollapseAll: () => void;
};

export const ExpandCollapseControls = ({
  onExpandAll,
  onCollapseAll
}: Props) => {
  const { t } = useTranslation('parts');

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <Button size="small" startIcon={<UnfoldMoreIcon />} onClick={onExpandAll}>
        {t('addPartModal.expandAll')}
      </Button>
      <Button
        size="small"
        startIcon={<UnfoldLessIcon />}
        onClick={onCollapseAll}
      >
        {t('addPartModal.collapseAll')}
      </Button>
    </Box>
  );
};
